import classNames from "classnames";
import * as React from "react";
import { useLocation } from "react-router-dom";

import { atCourseHomePage } from "features/classroom/routes/links";
import FadeIn from "features/common/components/FadeIn";

import styles from "./ClassroomStructure.module.scss";

type Props = {
  renderSidebar: () => React.ReactNode;
  children: React.ReactNode;
  edit?: boolean;
  courseId?: string;
  drawerOpen: boolean;
  onOverlayClick: () => void;
};

export default function ClassroomStructure({
  renderSidebar,
  edit,
  children,
  drawerOpen,
  onOverlayClick
}: Props) {
  const { pathname } = useLocation();
  const useNarrowBreakpoint = atCourseHomePage(pathname);

  return (
    <>
      <div className={styles.wrapper}>
        {children}
        <FadeIn show={drawerOpen}>
          <div
            onClick={onOverlayClick}
            className={classNames(styles.overlay, {
              [styles["overlay--narrow-breakpoint"]]: useNarrowBreakpoint,
              [styles["overlay--wide-breakpoint"]]: !useNarrowBreakpoint
            })}
          />
        </FadeIn>
        <div
          className={classNames(styles.sidebar, {
            [styles["sidebar--edit"]]: edit,
            [styles["sidebar--visible"]]: drawerOpen,
            [styles["sidebar--hidden"]]: !drawerOpen && !edit,
            [styles["sidebar--hidden--edit"]]: !drawerOpen && edit
          })}
          data-test="ClassroomStructureSidebar"
        >
          {renderSidebar()}
        </div>
      </div>
    </>
  );
}
